import AbstractRequestTask from '../../AbstractRequestTask';
import Launcher from '../../../apa/Launcher';
import store from '../../../../store';
import {ENABLE_MODAL_RETRIES} from '../../../RequestManagerConstants';

class ReadProfile extends AbstractRequestTask {
  constructor(params) {
    super();
    this.params = params;
  }

  getParams() {
    const params = super.getParams();
    const { user: { lasttouch: { profile = false } = {} } = {} } = store.getState(); // Destructuring a nested object with default value to avoid typeError
    if (profile) {
      params.lasttouch = profile;
    }
    return { ...params, ...this.params };
  }

  getUrl() {
    const http = 'https://';
    const url = Launcher.get('akamai_mfwk');
    return `${http}${url}/services/user/profile/read`;
  }

  isValid(data) {
    if (data.errors || data.status === 1 || data.response === 'error') {
      return false;
    }

    return true;
  }

  success(data, b) {
    this.resolve(data);
  }

  getShowErrorModal(){
		return ENABLE_MODAL_RETRIES;
	}
}

export default ReadProfile;



// WEBPACK FOOTER //
// ./src/requests/tasks/user/profile/ReadProfileTask.js